import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-targeting',
  	templateUrl: './toolcards-targeting.component.html',
  	styleUrls: ['./toolcards-targeting.component.scss']
})
export class ToolcardsTargetingComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
		console.log('toolcards-targeting')
  	}

}
